import { ENGINE_TITLE } from "component/vehicle-form/constants";
import { IFitmentOption } from "interfaces/session/IVehicle";
import getCustomSizeQuery from "util/url/getCustomSizeQuery";
import { isEmpty } from "../lodash/isEmpty";

export function buildFitmentString(updatedVehicle: any, showAllFitmentOptions = true) {
  let fitmentString = "";

  let updatedFitmentOption = [...updatedVehicle?.fitmentOptions || []];
  const customSizes = getCustomSizeQuery();
  if (customSizes && Object.keys(customSizes).length > 0 && updatedVehicle?.fitmentOptions?.length) {
    updatedFitmentOption = updatedVehicle.fitmentOptions.filter((_: IFitmentOption) => (_.optionName !== "vcdb.TireSizeAndPosition" && _.optionName !== "vcdb.WheelSizeAndPosition")); // As we need to replace it with factory sizes.
    Object.keys(customSizes).forEach((key) => {
      const val = customSizes[key];
      if (val) {
        updatedFitmentOption.push({
          optionName: key,
          optionValue: val,
        });
      }
    });

    updatedVehicle.fitmentOptions = [...updatedFitmentOption];
  }

  if (showAllFitmentOptions && updatedVehicle?.fitmentOptions?.length) {
    fitmentString = updatedVehicle.fitmentOptions.map((option: IFitmentOption) => option.optionValue).join(" ");
  }

  return fitmentString;
}

export function createVehicleDescription(vehicle: any, showEngineInfo = false, addComma = false, showAllFitmentOptions = false) {
  if (isEmpty(vehicle)) {
    return "ALL VEHICLES";
  }

  const updatedVehicle = { ...vehicle };
  const fitmentString = buildFitmentString(updatedVehicle, showAllFitmentOptions);
  const engineInfo = updatedVehicle?.fitmentOptions?.find((option: IFitmentOption) => option.optionName === ENGINE_TITLE);

  return `${updatedVehicle.year || updatedVehicle.vehicleYear}${addComma ? ", " : " "}${updatedVehicle.make || updatedVehicle.vehicleMake} ${updatedVehicle.model || updatedVehicle.vehicleModel} ${showEngineInfo ? (engineInfo?.optionValue || "") : ""}${fitmentString}`;
}
